import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { createUser, addUserRole } from "../Network/User"
import { listCompany } from "../Network/Company"
import { listDepartment, addUserToDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import { useHistory } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import MultiSelect from "react-multi-select-component";
import "./UserDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"

function CreateUser() {
    const rolecx = useContext(RoleContext)
    const prefixAuthority = "NEWS_"
    const globalAuthority = "SET_GLOBAL"
    const companyAuthority = "SET_COMPANY"

    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user;
    const langError = langCx.lang.error;
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();

    const [isLoading, setLoading] = useState(false);
    const [employeeId, setEmployeeId] = useState("");
    const [username, setUsername] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [position, setPosition] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [line, setLine] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isError, setError] = useState(false);
    const [isErrorPassword, setIsErrorPassword] = useState(false)

    const [isMobile, setMobile] = useState(false)
    const [isWeb, setWeb] = useState(false)
    const [isTablet, setTablet] = useState(false)
    const [isInformation, setIsInformation] = useState(false)

    const [companyList, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState("")
    const [departmentList, setDepartment] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([])

    const [role, setRole] = useState([])
    const [selectedRole, setSelectedRole] = useState("")

    const fetchCompany = () => {
        listCompany(
            (data)=>{
                setCompany(data)
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            }
        )
    }

    const fetchDepartment = (id) =>{
        listDepartment(id,
            (data)=>{
                setDepartment(data)
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            })
    }
    
    const fetchRole = () =>{
        listRole(1, 1000,
            (data)=>{
                var roleList = []
                data.forEach((item)=>{
                    roleList.push({value: item.id, label: item.roleName})
                })
                setRole(roleList)
            },
            (error)=>{
                notifyCx.showNotify(lang.something_wrong, error.message, 2)
            })
    }

    const addDepartment = (userId, departmentId) =>{
        addUserToDepartment(userId, departmentId,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(
                    lang.created_user,
                    firstname + " " + lastname + " " + lang.created_user_desc, 
                    0)
                history.goBack()
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
            })
    }

    const addRoleToUser = (userId, selectRole) =>{
        addUserRole(userId, selectRole,
            ()=>{  },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
            })
    }

    useEffect(() => {
        setDocumentTitle("Create user")
        fetchRole()
        fetchCompany()

        if(!rolecx.checkPermission(prefixAuthority, companyAuthority)){
            let companyId = localStorage.getItem("company_id")
            setSelectedCompany(companyId)
            fetchDepartment(companyId)
        }
    }, [])

    const onSubmit = () =>{
        if( !selectedCompany || !selectedDepartment ||
            !employeeId || !username || !firstname || !lastname || !position || 
            !phoneNumber || !email || !password || !confirmPassword){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }else if(password !== confirmPassword){
            notifyCx.showNotify(lang.password_not_match, lang.password_not_match_desc, 1)
            setError(true);
            return;
        }else if(!isMobile && !isTablet && !isWeb && !isInformation){
            notifyCx.showNotify(lang.access_not_select, lang.access_not_select_desc, 1)
            setError(true);
            return;
        }

        setLoading(true);
        createUser(
            employeeId,
            username,
            firstname,
            lastname,
            position,
            phoneNumber,
            line,
            email,
            password,
            isWeb,
            isMobile,
            isTablet,
            isInformation,
            (data)=>{
                addDepartment(data.id, selectedDepartment)
                addRoleToUser(data.id, selectedRole)
            },
            (error)=>{
                console.log(error.response)
                if(error.response !== undefined){
                    let passwordError = error.response.data.message
                    if(passwordError === "Password must be 6 - 32 alphanumeric characters."){
                        setIsErrorPassword(true)
                        notifyCx.showNotify(lang.password_at_least, lang.password_at_least_desc, 1)
                    }else{
                        notifyCx.showNotify("Something wrong", error.message, 2)
                    }
                }else{
                    notifyCx.showNotify("Something wrong", error.message, 2)
                }
                setLoading(false)
            }
        )
    }

    return (
        <>
        { isLoading ? <Loading title={lang.creating}/>: null }
        <div id="create-user">
            <HeaderTitle title={lang.create_user} isShowBack backTo="/user"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.company}</Form.Label>
                            <Form.Control as="select"
                            disabled={!rolecx.checkPermission(prefixAuthority, companyAuthority) ? true:false}
                            value={selectedCompany}
                            isInvalid={isError && !selectedCompany}
                            onChange={(e)=>{
                                setSelectedCompany(e.target.value)
                                if(e.target.value !== ""){
                                    setSelectedDepartment("")
                                    fetchDepartment(e.target.value)
                                }else{
                                    setDepartment([])
                                    setSelectedDepartment("")
                                }
                                
                            }}>
                                <option value="">{lang.select_company}</option>
                                { companyList.map((item, key)=>
                                <option key={key} value={item.id}>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.department}</Form.Label>
                            <Form.Control as="select"
                            disabled={!selectedCompany}
                            isInvalid={isError && !selectedDepartment}
                            onChange={(e)=>setSelectedDepartment(e.target.value)}>
                                <option value="">{lang.select_department}</option>
                                { departmentList.map((item, key)=>
                                <option key={key} value={item.id}>{item.name}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.employee_id}</Form.Label>
                            <Form.Control
                            value={employeeId}
                            isInvalid={isError && !employeeId}
                            onChange={(e)=>setEmployeeId(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.username}</Form.Label>
                            <Form.Control
                            placeholder=""
                            value={username}
                            isInvalid={isError && !username}
                            onChange={(e)=>setUsername(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.firstname}</Form.Label>
                            <Form.Control
                            placeholder=""
                            value={firstname}
                            isInvalid={isError && !firstname}
                            onChange={(e)=>setFirstname(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.lastname}</Form.Label>
                            <Form.Control
                            placeholder=""
                            value={lastname}
                            isInvalid={isError && !lastname}
                            onChange={(e)=>setLastname(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.position}</Form.Label>
                            <Form.Control
                            placeholder="Building Admin"
                            value={position}
                            isInvalid={isError && !position}
                            onChange={(e)=>setPosition(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.phone}</Form.Label>
                            <Form.Control
                            value={phoneNumber}
                            isInvalid={isError && !phoneNumber}
                            onChange={(e)=>setPhoneNumber(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.line}</Form.Label>
                            <Form.Control
                            value={line}
                            onChange={(e)=>setLine(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.email}</Form.Label>
                            <Form.Control
                            placeholder=""
                            value={email}
                            isInvalid={isError && !email}
                            onChange={(e)=>setEmail(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.password}</Form.Label>
                            <Form.Control
                            type="password"
                            value={password}
                            isInvalid={(isError && !password) || (isErrorPassword && (password.length < 6 || password.length > 32) ) }
                            onChange={(e)=>setPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.confirm_password}</Form.Label>
                            <Form.Control
                            type="password"
                            value={confirmPassword}
                            isInvalid={(isError && !confirmPassword) || (isErrorPassword && (confirmPassword.length < 6 || confirmPassword.length > 32))}
                            onChange={(e)=>setConfirmPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.role}</Form.Label>
                            {/* <MultiSelect
                            options={role}
                            value={selectedRole}
                            onChange={setSelectedRole}
                            
                            /> */}
                            <Form.Control as="select"
                            isInvalid={isError && !selectedRole}
                            value={selectedRole}
                            onChange={(e)=>{
                                setSelectedRole(e.target.value)
                            }}
                            >
                                <option value="">{lang.select_role}</option>
                                { role.map((item, key)=>
                                <option value={item.value} key={key}>
                                    {item.label}
                                </option>
                                )}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group >
                            <Form.Label>
                                {lang.access_platform}
                                <div className="label-desc">{lang.access_platform_desc}</div>
                            </Form.Label>
                            
                            <div style={{display: 'flex'}}>
                            <AccessItem title={lang.mobile} 
                            icon={faMobileAlt} isSelected={isMobile}
                            isError={!isMobile && !isWeb && !isTablet && !isInformation && isError}
                            onClick={()=>setMobile(!isMobile ? true: false)}
                            />
                            { rolecx.checkPermission("_MENU_", "app.admin_select") ?
                            <AccessItem title={lang.web_admin} 
                            icon={faGlobeAsia} isSelected={isWeb}
                            isError={!isMobile && !isWeb && !isTablet && !isInformation && isError}
                            onClick={()=>setWeb(!isWeb ? true: false)}
                            />
                            : null
                            }
                            { rolecx.checkPermission("_MENU_", "app.tablet_select") ?
                            <AccessItem title={lang.tablet} 
                            icon={faTabletAlt} isSelected={isTablet}
                            isError={!isMobile && !isWeb && !isTablet && !isInformation && isError}
                            onClick={()=>setTablet(!isTablet ? true: false)}
                            />
                            : null
                            }
                            { rolecx.checkPermission("_MENU_", "app.front_screen") ?
                            <AccessItem
                            title={lang.information_screen}
                            icon={faWindowMaximize}
                            isSelected={isInformation}
                            isError={!isMobile && !isWeb && !isTablet && !isInformation && isError}
                            onClick={()=>setIsInformation(!isInformation ? true:false)}
                            />
                            : null
                            }
                            </div>
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{lang.create_user}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

function AccessItem(props){
    return(
        <div className="access-item"
        onClick={props.onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
            </div>
        </div>
    )
}

function RoleList(){
    return(
        <div>
            <b className="title-role">Role</b>
            <div>
                <div className="role-item">
                    <div>System admin</div>
                    <div className="desc">Description here</div>
                </div>
            </div>
        </div>
    )
}

export default CreateUser
